module.exports = __webpack_public_path__ + "img/horizontal_4_6_2.10f99278.png";